import StoreModuleService from '../StoreModuleService';
import { initialState } from './state';
import Vue from 'vue';

// mutations declarations
export const SET_NODE_DATA = 'SET_NODE_DATA';
export const BULK_SET_NODES_DATA = 'BULK_SET_NODES_DATA';
export const DELETE_NODE = 'DELETE_NODE';
export const SET_LOADING_TEST_AND_CONTINUE = 'SET_LOADING_TEST_AND_CONTINUE';
export const UPDATE_NODE_PROPERTY = 'UPDATE_NODE_PROPERTY;';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_NODE_DATA](state, payload) {
		const { key, value } = payload;
		Vue.set(state.data, key, value);
	},
	[BULK_SET_NODES_DATA](state, { data }) {
		Vue.set(state, 'data', { ...state.data, ...data });
	},
	[DELETE_NODE](state, nodeId) {
		Vue.delete(state.data, nodeId);
	},
	[SET_LOADING_TEST_AND_CONTINUE](state, value) {
		state.loadingTestAndContinue = value;
	},
	[UPDATE_NODE_PROPERTY](state, payload) {
		const { id: nodeId, key, value } = payload;
		Vue.set(state.data[nodeId], key, value);
	},
};

export default mutations;
